<div class="At-Container ">
  <div class="At-StoryArea At-CustomScroll">
    <app-stories></app-stories>
  </div>
  <!-- At-StoryArea ends  -->
  <div class="At-Homepage">
    <!-- <div class="At-TabHeading d-flex">
      <div class="At-TabButton active" (click)="selectTab(0)">
        <h3>Discover</h3>
      </div>
      <div class="At-TabButton" (click)="selectTab(1)">
        <h3>Feed</h3>
      </div>
      <div class="At-TabButton ml-auto pr-0">
        <h3 class="At-TextBlue" (click)="openModal(template)">+ Create Post</h3>
      </div>
    </div> -->

    <div class="At-TabContent">
      <tabset #staticTabs class="At-Tabset">
        <tab heading="Discover">
          <div class="At-TabContent-Holder At-CustomScroll">
            <div class="row m-0">
              <div class="col-sm-6 col-md-6 col-lg-6 col-xl-4 At-ColPad25">
                <div class="At-PostBox">
                  <div class=" At-InfoBox At-InfoPost">
                    <div class="At-InfoImg">
                      <figure>
                        <img src="assets/images/profile/profile-small.png" class="img-fluid " alt="">
                        <div class="At-badgePurple"><i class="icon-bage"></i></div>
                      </figure>
                    </div>
                    <div class="At-InfoTitle d-flex ">
                      <div (click)="toggleShowActivity()" class="At-TitleLeft At-CursorPointer">
                        <h5>Julian • <span class="At-TextRedLight">jona</span> • <span class="At-TextRedLight">COO</span>
                        </h5>
                        <h6><i class="icon-location"></i>London, UK • <span>2m ago</span></h6>
                      </div>
                      <div class="At-TitleRight">
                        <i class="icon-user-add"></i>
                        <div class="btn-group At-DropdownBox" dropdown>
                          <button id="button-basic5" dropdownToggle type="button" class="dropdown-toggle" aria-controls="dropdown-basic5"><i class="icon-more"></i></button>
                          <ul id="dropdown-basic5" *dropdownMenu class="dropdown-menu" role="menu" aria-labelledby="button-basic5">
                            <li role="menuitem"><a href="#"> <i class="icon-notification-1"></i> turn on post notification</a></li>
                            <li role="menuitem"><a href="#"> <i class="icon-copy"></i> copy link</a></li>
                            <li role="menuitem"><a href="#"> <i class="icon-user-cancel"></i> remove from contacts</a></li>
                            <li role="menuitem"><a href="#"> <i class="icon-sound-off"></i> mute</a></li>
                            <li role="menuitem" class="At-Footerbtns">
                              <button type="button" class="At-Report">report</button>
                              <button type="button" class="At-Block At-TextRed">Block</button>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="At-PostMainImg">
                    <figure>
                      <div class="AtImgOverlay"></div>
                      <img src="assets/images/posts/post-img1.jpg" class="img-fluid w-100" alt="">
                    </figure>
                    <ul class="At-PostShareUl d-flex align-items-center">
                      <li>
                        <h6><i class="icon-like"></i> 2211</h6>
                      </li>
                      <li>
                        <h6 (click)="toggleShowComment()"><i class="icon-comment"></i>150</h6>
                      </li>
                      <li>
                        <h6 (click)="toggleShare()"><i class="icon-send"></i>221</h6>
                      </li>
                    </ul>
                    <i class="icon-save"></i>
                  </div>
                  <div class="At-PostDescription">
                    <p>Lorem ipsum dolor sit amet, consectetur adiping elit, sed do eiusmod tempor incididunt ...</p>
                  </div>
                </div>
                <!-- At-PostBox ends -->
              </div>
              <!-- col ends -->

              <div class="col-sm-6 col-md-6 col-lg-6 col-xl-4 At-ColPad25">
                <div class="At-PostBox">
                  <div class="At-InfoBox At-InfoPost">
                    <div class="At-InfoImg">
                      <figure>
                        <img src="assets/images/profile/profile-small2.png" class="img-fluid " alt="">
                      </figure>
                    </div>
                    <div class="At-InfoTitle  d-flex ">
                      <div (click)="toggleShowActivity()" class="At-TitleLeft At-CursorPointer">
                        <h5>Nathaniel.DS • <span>sufer</span></h5>
                        <h6><i class="icon-location"></i>NewYork, USA • <span>42m ago</span></h6>
                      </div>
                      <div class="At-TitleRight">
                        <i class="icon-more"></i>
                      </div>
                    </div>
                  </div>
                  <div class="At-PostMainImg">
                    <figure>
                      <div class="AtImgOverlay"></div>
                      <img src="assets/images/posts/post-img2.jpg" class="img-fluid w-100" alt="">
                    </figure>
                    <ul class="At-PostShareUl d-flex align-items-center">
                      <li>
                        <h6><i class="icon-like"></i> 2211</h6>
                      </li>
                      <li>
                        <h6 (click)="toggleShowComment()"><i class="icon-comment"></i>150</h6>
                      </li>
                      <li>
                        <h6 (click)="toggleShare()"><i class="icon-send"></i>221</h6>
                      </li>
                    </ul>
                  </div>
                  <div class="At-PostDescription">
                    <p>Lorem ipsum dolor sit amet, consectetur adiping elit, sed do eiusmod tempor incididunt ...</p>
                  </div>
                </div>
                <!-- At-PostBox ends -->
              </div>
              <!-- col ends -->

              <div class="col-sm-6 col-md-6 col-lg-6 col-xl-4 At-ColPad25">
                <div class="At-PostBox">
                  <div class="At-InfoBox At-InfoPost">
                    <div class="At-InfoImg">
                      <figure>
                        <img src="assets/images/profile/profile-small3.png" class="img-fluid" alt="">
                      </figure>
                    </div>
                    <div class="At-InfoTitle d-flex ">
                      <div (click)="toggleShowActivity()" class="At-TitleLeft At-CursorPointer">
                        <h5>Anita • <span>ezzy</span></h5>
                        <h6><i class="icon-location"></i> London, UK • <span>2hrs ago</span></h6>
                      </div>
                      <div class="At-TitleRight">
                        <i class="icon-user-add"></i>
                        <i class="icon-more"></i>
                      </div>
                    </div>
                  </div>
                  <div class="At-PostMainImg">
                    <figure>
                      <div class="AtImgOverlay"></div>
                      <img src="assets/images/posts/post-img3.jpg" class="img-fluid w-100" alt="">
                    </figure>
                    <ul class="At-PostShareUl d-flex align-items-center">
                      <li>
                        <h6><i class="icon-like"></i> 2211</h6>
                      </li>
                      <li>
                        <h6 (click)="toggleShowComment()"><i class="icon-comment"></i>150</h6>
                      </li>
                      <li>
                        <h6 (click)="toggleShare()"><i class="icon-send"></i>221</h6>
                      </li>
                    </ul>
                  </div>
                  <div class="At-PostDescription">
                    <p>Lorem ipsum dolor sit amet, consectetur adiping elit, sed do eiusmod tempor incididunt ...</p>
                  </div>
                </div>
                <!-- At-PostBox ends -->
              </div>
              <!-- col ends -->

              <div class="col-sm-6 col-md-6 col-lg-6 col-xl-4 At-ColPad25">
                <div class="At-PostBox">
                  <div class="At-InfoBox At-InfoPost">
                    <div class="At-InfoImg">
                      <figure>
                        <img src="assets/images/profile/profile-small4.png" class="img-fluid" alt="">
                      </figure>
                    </div>
                    <div class="At-InfoTitle d-flex ">
                      <div (click)="toggleShowActivity()" class="At-TitleLeft At-CursorPointer">
                        <h5>Julian • <span>jona</span> • <span>COO</span></h5>
                        <h6><i class="icon-location"></i>London, UK • <span>2m ago</span></h6>
                      </div>
                      <div class="At-TitleRight">
                        <i class="icon-more"></i>
                      </div>
                    </div>
                  </div>
                  <div class="At-PostMainImg">
                    <figure>
                      <div class="AtImgOverlay"></div>
                      <img src="assets/images/posts/post-img4.jpg" class="img-fluid w-100" alt="">
                    </figure>
                    <ul class="At-PostShareUl d-flex align-items-center">
                      <li>
                        <h6><i class="icon-like"></i> 2211</h6>
                      </li>
                      <li>
                        <h6 (click)="toggleShowComment()"><i class="icon-comment"></i>150</h6>
                      </li>
                      <li>
                        <h6 (click)="toggleShare()"><i class="icon-send"></i>221</h6>
                      </li>
                    </ul>
                  </div>
                  <div class="At-PostDescription">
                    <p>Lorem ipsum dolor sit amet, consectetur adiping elit, sed do eiusmod tempor incididunt ...</p>
                  </div>
                </div>
                <!-- At-PostBox ends -->
              </div>
              <!-- col ends -->

              <div class="col-sm-6 col-md-6 col-lg-6 col-xl-4 At-ColPad25">
                <div class="At-PostBox">
                  <div class="At-InfoBox At-InfoPost">
                    <div class="At-InfoImg">
                      <figure>
                        <img src="assets/images/profile/profile-small5.png" class="img-fluid " alt="">
                      </figure>
                    </div>
                    <div class="At-InfoTitle d-flex ">
                      <div (click)="toggleShowActivity()" class="At-TitleLeft At-CursorPointer">
                        <h5>Julian • <span>jona</span> • <span>COO</span></h5>
                        <h6><i class="icon-location"></i>London, UK • <span>2m ago</span></h6>
                      </div>
                      <div class="At-TitleRight">
                        <i class="icon-more"></i>
                      </div>
                    </div>
                  </div>
                  <!-- At-InfoBox ends  -->
                  <div class="At-PostMainImg">
                    <figure>
                      <div class="AtImgOverlay"></div>
                      <img src="assets/images/posts/post-img5.jpg" class="img-fluid w-100" alt="">
                    </figure>
                    <ul class="At-PostShareUl d-flex align-items-center">
                      <li>
                        <h6><i class="icon-like"></i> 2211</h6>
                      </li>
                      <li>
                        <h6 (click)="toggleShowComment()"><i class="icon-comment"></i>150</h6>
                      </li>
                      <li>
                        <h6 (click)="toggleShare()"><i class="icon-send"></i>221</h6>
                      </li>
                    </ul>
                  </div>
                  <div class="At-PostDescription">
                    <p>Lorem ipsum dolor sit amet, consectetur adiping elit, sed do eiusmod tempor incididunt ...</p>
                  </div>
                </div>
                <!-- At-PostBox ends -->
              </div>
              <!-- col ends -->
              <div class="col-sm-6 col-md-6 col-lg-6 col-xl-4 At-ColPad25">
                <div class="At-PostBox">
                  <div class="At-InfoBox At-InfoPost">
                    <div class="At-InfoImg">
                      <figure>
                        <img src="assets/images/profile/profile-small6.png" class="img-fluid " alt="">
                      </figure>
                    </div>
                    <div class="At-InfoTitle d-flex">
                      <div (click)="toggleShowActivity()" class="At-TitleLeft At-CursorPointer">
                        <h5>Anatoli • <span class="At-TextPurple">matt</span> • <span class="At-TextPurple">Project
                            Manager</span></h5>
                        <h6><i class="icon-location"></i>London, UK • <span>2m ago</span></h6>
                      </div>
                      <div class="At-TitleRight">
                        <i class="icon-more"></i>
                      </div>
                    </div>
                  </div>
                  <!-- At-InfoBox ends  -->
                  <div class="At-PostMainImg">
                    <figure>
                      <div class="AtImgOverlay"></div>
                      <img src="assets/images/posts/post-img6.jpg" class="img-fluid w-100" alt="">
                    </figure>
                    <ul class="At-PostShareUl d-flex align-items-center">
                      <li>
                        <h6><i class="icon-like"></i> 2211</h6>
                      </li>
                      <li>
                        <h6 (click)="toggleShowComment()"><i class="icon-comment"></i>150</h6>
                      </li>
                      <li>
                        <h6 (click)="toggleShare()"><i class="icon-send"></i>221</h6>
                      </li>
                    </ul>
                  </div>
                  <!-- At-PostMainImg ends  -->
                  <div class="At-PostDescription">
                    <p>Lorem ipsum dolor sit amet, consectetur adiping elit, sed do eiusmod tempor incididunt ...</p>
                  </div>
                </div>
                <!-- At-PostBox ends -->
              </div>
              <!-- col ends -->

            </div>
          </div>
        </tab>
        <tab heading="Feed">
          <div class="At-TabContent-Holder At-CustomScroll">
            <div class="row m-0">
              <div class="col-md-4 At-ColPad25">
                <div class="At-PostBox">
                  <div class="At-InfoBox At-InfoPost">
                    <div class="At-InfoImg">
                      <figure>
                        <img src="assets/images/profile/profile-small2.png" class="img-fluid " alt="">
                      </figure>
                    </div>
                    <div class="At-InfoTitle  d-flex ">
                      <div (click)="toggleShowActivity()" class="At-TitleLeft At-CursorPointer">
                        <h5>Nathaniel.DS • <span>sufer</span></h5>
                        <h6><i class="icon-location"></i>NewYork, USA • <span>42m ago</span></h6>
                      </div>
                      <div class="At-TitleRight">
                        <i class="icon-more"></i>
                      </div>
                    </div>
                  </div>
                  <div class="At-PostMainImg">
                    <figure>
                      <div class="AtImgOverlay"></div>
                      <img src="assets/images/posts/post-img2.jpg" class="img-fluid w-100" alt="">
                    </figure>
                    <ul class="At-PostShareUl d-flex align-items-center">
                      <li>
                        <h6><i class="icon-like"></i> 2211</h6>
                      </li>
                      <li>
                        <h6 (click)="toggleShowComment()"><i class="icon-comment"></i>150</h6>
                      </li>
                      <li>
                        <h6 (click)="toggleShare()"><i class="icon-send"></i>221</h6>
                      </li>
                    </ul>
                  </div>
                  <div class="At-PostDescription">
                    <p>Lorem ipsum dolor sit amet, consectetur adiping elit, sed do eiusmod tempor incididunt ...</p>
                  </div>
                </div>
                <!-- At-PostBox ends -->
              </div>
              <!-- col ends -->

              <div class="col-md-4 At-ColPad25">
                <div class="At-PostBox">
                  <div class=" At-InfoBox At-InfoPost">
                    <div class="At-InfoImg">
                      <figure>
                        <img src="assets/images/profile/profile-small.png" class="img-fluid " alt="">
                        <div class="At-badgePurple"><i class="icon-bage"></i></div>
                      </figure>
                    </div>
                    <div class="At-InfoTitle d-flex ">
                      <div (click)="toggleShowActivity()" class="At-TitleLeft At-CursorPointer">
                        <h5>Julian • <span class="At-TextRedLight">jona</span> • <span class="At-TextRedLight">COO</span>
                        </h5>
                        <h6><i class="icon-location"></i>London, UK • <span>2m ago</span></h6>
                      </div>
                      <div class="At-TitleRight">
                        <i class="icon-user-add"></i>
                        <i class="icon-more"></i>
                      </div>
                    </div>
                  </div>
                  <div class="At-PostMainImg">
                    <figure>
                      <div class="AtImgOverlay"></div>
                      <img src="assets/images/posts/post-img1.jpg" class="img-fluid w-100" alt="">
                    </figure>
                    <ul class="At-PostShareUl d-flex align-items-center">
                      <li>
                        <h6><i class="icon-like"></i> 2211</h6>
                      </li>
                      <li>
                        <h6 (click)="toggleShowComment()"><i class="icon-comment"></i>150</h6>
                      </li>
                      <li>
                        <h6 (click)="toggleShare()"><i class="icon-send"></i>221</h6>
                      </li>
                    </ul>
                    <i class="icon-save"></i>
                  </div>
                  <div class="At-PostDescription">
                    <p>Lorem ipsum dolor sit amet, consectetur adiping elit, sed do eiusmod tempor incididunt ...</p>
                  </div>
                </div>
                <!-- At-PostBox ends -->
              </div>
              <!-- col ends -->

              <div class="col-md-4 At-ColPad25">
                <div class="At-PostBox">
                  <div class="At-InfoBox At-InfoPost">
                    <div class="At-InfoImg">
                      <figure>
                        <img src="assets/images/profile/profile-small3.png" class="img-fluid" alt="">
                      </figure>
                    </div>
                    <div class="At-InfoTitle d-flex ">
                      <div (click)="toggleShowActivity()" class="At-TitleLeft At-CursorPointer">
                        <h5>Anita • <span>ezzy</span></h5>
                        <h6><i class="icon-location"></i> London, UK • <span>2hrs ago</span></h6>
                      </div>
                      <div class="At-TitleRight">
                        <i class="icon-user-add"></i>
                        <i class="icon-more"></i>
                      </div>
                    </div>
                  </div>
                  <div class="At-PostMainImg">
                    <figure>
                      <div class="AtImgOverlay"></div>
                      <img src="assets/images/posts/post-img3.jpg" class="img-fluid w-100" alt="">
                    </figure>
                    <ul class="At-PostShareUl d-flex align-items-center">
                      <li>
                        <h6><i class="icon-like"></i> 2211</h6>
                      </li>
                      <li>
                        <h6 (click)="toggleShowComment()"><i class="icon-comment"></i>150</h6>
                      </li>
                      <li>
                        <h6 (click)="toggleShare()"><i class="icon-send"></i>221</h6>
                      </li>
                    </ul>
                  </div>
                  <div class="At-PostDescription">
                    <p>Lorem ipsum dolor sit amet, consectetur adiping elit, sed do eiusmod tempor incididunt ...</p>
                  </div>
                </div>
                <!-- At-PostBox ends -->
              </div>
              <!-- col ends -->

              <div class="col-md-4 At-ColPad25">
                <div class="At-PostBox">
                  <div class="At-InfoBox At-InfoPost">
                    <div class="At-InfoImg">
                      <figure>
                        <img src="assets/images/profile/profile-small4.png" class="img-fluid" alt="">
                      </figure>
                    </div>
                    <div class="At-InfoTitle d-flex ">
                      <div (click)="toggleShowActivity()" class="At-TitleLeft At-CursorPointer">
                        <h5>Julian • <span>jona</span> • <span>COO</span></h5>
                        <h6><i class="icon-location"></i>London, UK • <span>2m ago</span></h6>
                      </div>
                      <div class="At-TitleRight">
                        <i class="icon-more"></i>
                      </div>
                    </div>
                  </div>
                  <div class="At-PostMainImg">
                    <figure>
                      <div class="AtImgOverlay"></div>
                      <img src="assets/images/posts/post-img4.jpg" class="img-fluid w-100" alt="">
                    </figure>
                    <ul class="At-PostShareUl d-flex align-items-center">
                      <li>
                        <h6><i class="icon-like"></i> 2211</h6>
                      </li>
                      <li>
                        <h6 (click)="toggleShowComment()"><i class="icon-comment"></i>150</h6>
                      </li>
                      <li>
                        <h6 (click)="toggleShare()"><i class="icon-send"></i>221</h6>
                      </li>
                    </ul>
                  </div>
                  <div class="At-PostDescription">
                    <p>Lorem ipsum dolor sit amet, consectetur adiping elit, sed do eiusmod tempor incididunt ...</p>
                  </div>
                </div>
                <!-- At-PostBox ends -->
              </div>
              <!-- col ends -->

              <div class="col-md-4 At-ColPad25">
                <div class="At-PostBox">
                  <div class="At-InfoBox At-InfoPost">
                    <div class="At-InfoImg">
                      <figure>
                        <img src="assets/images/profile/profile-small5.png" class="img-fluid " alt="">
                      </figure>
                    </div>
                    <div class="At-InfoTitle d-flex ">
                      <div (click)="toggleShowActivity()" class="At-TitleLeft At-CursorPointer">
                        <h5>Julian • <span>jona</span> • <span>COO</span></h5>
                        <h6><i class="icon-location"></i>London, UK • <span>2m ago</span></h6>
                      </div>
                      <div class="At-TitleRight">
                        <i class="icon-more"></i>
                      </div>
                    </div>
                  </div>
                  <!-- At-InfoBox ends  -->
                  <div class="At-PostMainImg">
                    <figure>
                      <div class="AtImgOverlay"></div>
                      <img src="assets/images/posts/post-img5.jpg" class="img-fluid w-100" alt="">
                    </figure>
                    <ul class="At-PostShareUl d-flex align-items-center">
                      <li>
                        <h6><i class="icon-like"></i> 2211</h6>
                      </li>
                      <li>
                        <h6 (click)="toggleShowComment()"><i class="icon-comment"></i>150</h6>
                      </li>
                      <li>
                        <h6 (click)="toggleShare()"><i class="icon-send"></i>221</h6>
                      </li>
                    </ul>
                  </div>
                  <div class="At-PostDescription">
                    <p>Lorem ipsum dolor sit amet, consectetur adiping elit, sed do eiusmod tempor incididunt ...</p>
                  </div>
                </div>
                <!-- At-PostBox ends -->
              </div>
              <!-- col ends -->
              <div class="col-md-4 At-ColPad25">
                <div class="At-PostBox">
                  <div class="At-InfoBox At-InfoPost">
                    <div class="At-InfoImg">
                      <figure>
                        <img src="assets/images/profile/profile-small6.png" class="img-fluid " alt="">
                      </figure>
                    </div>
                    <div class="At-InfoTitle d-flex">
                      <div (click)="toggleShowActivity()" class="At-TitleLeft At-CursorPointer">
                        <h5>Anatoli • <span class="At-TextPurple">matt</span> • <span class="At-TextPurple">Project
                            Manager</span></h5>
                        <h6><i class="icon-location"></i>London, UK • <span>2m ago</span></h6>
                      </div>
                      <div class="At-TitleRight">
                        <i class="icon-more"></i>
                      </div>
                    </div>
                  </div>
                  <!-- At-InfoBox ends  -->
                  <div class="At-PostMainImg">
                    <figure>
                      <div class="AtImgOverlay"></div>
                      <img src="assets/images/posts/post-img6.jpg" class="img-fluid w-100" alt="">
                    </figure>
                    <ul class="At-PostShareUl d-flex align-items-center">
                      <li>
                        <h6><i class="icon-like"></i> 2211</h6>
                      </li>
                      <li>
                        <h6 (click)="toggleShowComment()"><i class="icon-comment"></i>150</h6>
                      </li>
                      <li>
                        <h6 (click)="toggleShare()"><i class="icon-send"></i>221</h6>
                      </li>
                    </ul>
                  </div>
                  <!-- At-PostMainImg ends  -->
                  <div class="At-PostDescription">
                    <p>Lorem ipsum dolor sit amet, consectetur adiping elit, sed do eiusmod tempor incididunt ...</p>
                  </div>
                </div>
                <!-- At-PostBox ends -->
              </div>
              <!-- col ends -->

            </div>
          </div>
        </tab>
      </tabset>
      <div class="At-CreateButton ml-auto pr-0">
        <h3 class="At-TextBlue" (click)="openModal(template)">+ Create Post</h3>
      </div>

      <!-- tabset ends  -->
      <div class="At-SidebarOuter ">
       <div *ngIf="isShare" class="At-AppSharePost" >
          <app-share-post (onClose)="closeShare()"></app-share-post>
        </div>
       <div *ngIf="isShowComment" class="At-AppCommentPost">
          <app-comment-post (onClose)="closeComment()"></app-comment-post>
        </div>
        <div *ngIf="isShowActivity" class="At-AppActivityPost">
          <app-activity-post (onClose)="closeActivity()"></app-activity-post>
        </div>
      </div>
      <!-- At-Sidebar ends  -->
    </div>
    <!-- At-TabContent ends -->

  </div>
  <!-- At-Homepage ends -->
</div>
<ng-template #template>
  <div class="modal-header d-flex align-items-center">
    <h3 class="modal-title pull-left">Create A Post</h3>
    <button type="button" class="close At-ModalClose" aria-label="Close" (click)="modalRef.hide()">
      <i class="icon-cancel"></i>
    </button>
  </div>
  <div class="At-ModalBodyOne" *ngIf="div1">
    <div class="modal-body">
      <div class="At-ModalHeading d-flex justify-content-between align-items-center">
        <h4>Gallery</h4>
        <i class="icon-camera"></i>
      </div>
      <div class="At-ModalGallery">
        <ul>
          <li>
            <figure>
              <img src="assets/images/posts/post-img2.jpg" class="img-fluid" alt="">
            </figure>
            <h5>Recent</h5>
            <p class="At-Font16">14 items</p>
          </li>
          <li>
            <figure>
              <img src="assets/images/posts/post-img1.jpg" class="img-fluid" alt="">
            </figure>
            <h5>Favourites</h5>
            <p class="At-Font16">14 items</p>
          </li>
          <li>
            <figure>
              <img src="assets/images/posts/media3.jpg" class="img-fluid" alt="">
            </figure>
            <h5>Videos</h5>
            <p class="At-Font16">14 items</p>
          </li>
          <li>
            <figure>
              <img src="assets/images/posts/media4.jpg" class="img-fluid" alt="">
            </figure>
            <h5>ScreenShots</h5>
            <p class="At-Font16">14 items</p>
          </li>
          <li>
            <figure>
              <img src="assets/images/posts/media5.jpg" class="img-fluid" alt="">
            </figure>
            <h5>Selfies</h5>
            <p class="At-Font16">14 items</p>
          </li>
          <li>
            <figure>
              <img src="assets/images/posts/media6.jpg" class="img-fluid" alt="">
            </figure>
            <h5>Panoramas</h5>
            <p class="At-Font16">14 items</p>
          </li>

        </ul>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" (click)="div1Function()" class="At-Btn At-ModalBtn">NEXT</button>
    </div>
  </div>
  <div class="At-ModalBodyTwo" *ngIf="div2">
    <div class="modal-body">
      <div class="At-ModalHeading d-flex justify-content-between align-items-center">
        <a class="At-BtnBack At-BtnLinkBlue" href="javascript:void(0);" (click)="back1Function()">
          <i class="icon-back-arrow"></i>
          <h6>BACK</h6>
        </a>
      </div>
      <div class="At-ModalGallery mb-5">
        <ul>
          <li>
            <figure>
              <img src="assets/images/posts/media1.jpg" class="img-fluid" alt="">
            </figure>
          </li>
          <li>
            <figure class="At-FigureAdd">
              <i class="icon-add"></i>
            </figure>
          </li>

        </ul>
      </div>
      <div class="At-ModalForm">
        <div class="form-group mb-5">
          <input type="text" class="form-control" placeholder="Add Caption">
        </div>
        <div class="form-group">
          <input type="text" class="form-control" placeholder="Add Location">
        </div>
        <ul class="At-TagUl mb-5">
          <li>
            Newyork City
          </li>
          <li>
            TimeSquare, NY
          </li>
        </ul>
      </div>
    </div>
    <div class="At-ModalContacts">
      <h5>My Contacts <i class="icon-right-arrow "></i></h5>
      <p>Only people in my contacts can see my post</p>
    </div>
    <div class="modal-footer">
      <button type="button" (click)="div2Function()" class="At-Btn At-ModalBtn">NEXT</button>
    </div>
  </div>
  <div class="At-ModalBodyThree" *ngIf="div3">
    <div class="modal-body">
      <div class="At-ModalHeading d-flex justify-content-between align-items-center">
        <a class="At-BtnBack At-BtnLinkBlue" href="javascript:void(0);" (click)="back2Function()">
          <i class="icon-back-arrow"></i>
          <h6>BACK</h6>
        </a>
      </div>

      <div class="At-ModalForm mb-5">
        <div class="form-group">
          <div class="At-InputWithIcon">
            <i class="icon-search"></i>
            <input type="text" class="form-control" placeholder="Find a Location">
          </div>
        </div>
        <h6>Lahore, Pakistan</h6>
      </div>
      <div class="At-SelectLocation">
        <h6>Emporium Mall</h6>
        <p>Johar Town</p>
      </div>
      <div class="At-SelectLocation">
        <h6>G1 Market</h6>
        <p>Johar Town</p>
      </div>
      <div class="At-SelectLocation">
        <h6>Abdalian Society</h6>
        <p>Johar Town</p>
      </div>
      <div class="At-SelectLocation">
        <h6>Emporium Mall</h6>
        <p>Johar Town</p>
      </div>
      <div class="At-SelectLocation">
        <h6>G5 Market</h6>
        <p>Johar Town</p>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="At-Btn At-ModalBtn">NEXT</button>
    </div>
  </div>
</ng-template>
  <!-- At-ModalBodyOne ends  -->

<!-- create a post modal  -->

